/**
 * Conditionally joins class names.
 * Filters out falsy values, joins with single space, trims whitespace.
 *
 * @example
 * cn(styles.progress_bar_container, onMilestoneBarClick && styles.clickable)
 * // => "progress_bar_container_abc123 clickable_def456" when condition is true
 * // => "progress_bar_container_abc123" when condition is false
 */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(" ").trim();
}
